<section class="app-container">
  <div class="maintenance-screen"><img src="assets/logo/pro/logo.jpg" height="50px" class="maintenance-screen-logo" />
    <h5 class="maintenance-screen-message">The Site is in Planned Maintenance</h5>
    @if (!!showDates) {
      <h6 class="maintenance-screen-date">The Site will be in maintenance from {{dateFrom}} until
      {{dateUntil}}</h6>
    }
    <span class="btn btn-maintenance" (click)="goHomePage()">
      <span class="textButton">Go to Homepage</span>
    </span>
  </div>
</section>